import { Divider } from 'antd'
import React from 'react'

const Features = () => {
    return (
        <div className='web-features  section-padding-y '>
            <div className='w-80 container'>
                <h1 style={{fontWeight:600}}>Grow your page</h1>
                <Divider/>
                <div className="row d-flex justify-content-between mt-4" >
                    <div className='col-md-5'>
                        <h5 className='web-feature-sub-point-heading'>Superfast 🚀</h5>
                        <p>Takes less than 2 minutes to setup the page! Just login and setup the page and you're good to go! 
                        </p>
                        <p>We believe in minimalism, hence we provide a single table where you can display your content, That's it!</p>
                        <p>Check our template <a href='https://nonstop-heart-099.notion.site/Welcome-to-Notion-Diary-fa99cdadc9a149f58bf8004022401939' target="_blank" rel="noreferrer"  > page.</a></p>
                    </div>
                    <div className='col-md-5'>
                        <h5 className='web-feature-sub-point-heading'>We deliver your page as it should be!</h5>
                        <p>You can add multiple headings, images, custom stylings, tables and much more! We'll handle it. </p><p>Moreover you can add social links to Buy Me A Coffee, Twitter and Instagram. We make sure you get your reach 😉</p>
                    </div>
                </div>
            </div>
            
        </div>
    )
}

export default Features
